import { z } from 'zod';

export const movementDirectionSchema = z.enum(['IN', 'OUT', 'ADJ']);
export type MovementDirection = z.infer<typeof movementDirectionSchema>;

export const stockMovementListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(200).default(50),
  periodId: z.string().uuid().optional(),
  direction: movementDirectionSchema.optional(),
  lotId: z.string().uuid().optional(),
  productId: z.string().uuid().optional(),
  documentId: z.string().uuid().optional(),
  occurredAtFrom: z.string().datetime().optional(),
  occurredAtTo: z.string().datetime().optional(),
});
export type StockMovementListQuery = z.infer<typeof stockMovementListQuerySchema>;

export const stockMovementResponseSchema = z.object({
  id: z.string(),
  periodId: z.string(),
  occurredAt: z.string(),
  direction: movementDirectionSchema,
  qty: z.number(),
  lotId: z.string(),
  lotCode: z.string(),
  productId: z.string(),
  productCode: z.string(),
  productName: z.string(),
  documentId: z.string().nullable(),
  documentType: z.string().nullable(),
  documentCode: z.string().nullable(),
  reason: z.string().nullable(),
});
export type StockMovementResponse = z.infer<typeof stockMovementResponseSchema>;

export const stockMovementListResponseSchema = z.object({
  items: z.array(stockMovementResponseSchema),
  total: z.number().int().nonnegative(),
  page: z.number().int().positive(),
  pageSize: z.number().int().positive(),
});
export type StockMovementListResponse = z.infer<typeof stockMovementListResponseSchema>;
